export default __webpack_public_path__ + "static/media/src_convert7776_mobile_3.6a153055.jpg";